import type {} from "@lit/react";
import { DashboardLayout as DashboardLayoutElement, } from "@vaadin/dashboard/vaadin-dashboard-layout.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { DashboardLayoutElement, };
export type DashboardLayoutEventMap = Readonly<{}>;
const events = {} as DashboardLayoutEventMap;
export type DashboardLayoutProps = WebComponentProps<DashboardLayoutElement, DashboardLayoutEventMap>;
export const DashboardLayout = createComponent({
    elementClass: DashboardLayoutElement, events, react: React, tagName: "vaadin-dashboard-layout"
});
